<template>
  <div class="h5-empty-init-skeleton">
    <div class="skeleton skeleton-1" />
    <div class="wrapper">
      <div class="skeleton skeleton-2" />
      <div class="skeleton skeleton-3" />
      <div class="skeleton skeleton-4" />
      <div class="skeleton skeleton-5" />
      <div class="skeleton skeleton-6" />
      <div class="skeleton skeleton-7" />
    </div>
  </div>
</template>

<script setup>
</script>

<style lang='less' scoped>
.h5-empty-init-skeleton {
  background-color: white;
  .skeleton-1 {
    width: 100%;
    height: 393px;
    border-radius: 0;
  }
  .wrapper {
    padding: 0 12px;
    margin-top: 16px;
    .skeleton-2 {
      width: 100%;
      height: 80px;
      margin-bottom: 16px;
      border-radius: 4px;
    }
    .skeleton-3 {
      width: 240px;
      height: 16px;
      margin-top: 8px;
      border-radius: 2px;
    }
    .skeleton-4 {
      margin-top: 24px;
      height: 36px;
      border-radius: 4px;
    }
    .skeleton-5 {
      margin-top: 8px;
      height: 18px;
      width: 240px;
    }
    .skeleton-6 {
      margin-top: 6px;
      width: 320px;
      height: 16px;
      border-radius: 2px;
    }
  }

  .skeleton {
    animation: skeleton-animate 1.3s cubic-bezier(0.4,0,0.2,1) infinite forwards;
  }

  @keyframes skeleton-animate {
    0% {
      background-color: #EBEBEB;
    }
    25% {
      background-color: #F8F8F8;
    }
    80% {
      background-color: #EBEBEB;
    }
    100% {
      background-color: #EBEBEB;
    }
  }
}
</style>
